const PROMO_TO_COUPON = Object.freeze({
  trial50: 'TRIAL50',
  renewal20: 'RENEWAL20',
  invite_welcome: 'INVITE_WELCOME',
  newyear2026: 'NEWYEAR2026',
  private99: 'PRIVATE99',
  brochureqr2026: 'BROCHUREQR2026',
  exhibition2026: 'EXHIBITION2026',
  pro50: 'PRO50OCT',
});

export const resolvePaymentCouponCode = (couponCode, promoCode) => (
  couponCode
  || PROMO_TO_COUPON[String(promoCode || '').toLowerCase()]
  || null
);
